// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Organizations.css */

.programs-container {
  min-width: 1200px;
  margin: 50px auto;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.add-organization-button, .add-configuration-button {
  padding: 10px 20px;
  margin-bottom: 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.ag-theme-alpine {
  height: 400px;
  width: 80%;
  margin: auto;
}

.error-message {
  color: red;
  margin-bottom: 20px;
}

.icon-button {
  background: none;
  border: none;
  cursor: pointer;
}

.icon-button svg {
  font-size: 24px;
  color: #007bff;
}

.icon-button svg:hover {
  color: #0056b3;
}

.modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 10px;
  max-width: 600px;
  width: 100%;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
}

.organization-form, .configuration-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.form-group label {
  min-width: 200px;
  text-align: right;
  padding-right: 10px;
}

.form-group input,
.form-group textarea,
.form-group select {
  min-width: 300px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
}

.modal-actions button {
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.modal-actions button[type="submit"] {
  background-color: #4caf50;
  color: #fff;
}

.modal-actions button[type="button"] {
  background-color: #ccc;
}

.modal-actions .delete-button {
  background-color: #f44336;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProgramManager.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":["/* src/components/Organizations.css */\n\n.programs-container {\n  min-width: 1200px;\n  margin: 50px auto;\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.add-organization-button, .add-configuration-button {\n  padding: 10px 20px;\n  margin-bottom: 20px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.ag-theme-alpine {\n  height: 400px;\n  width: 80%;\n  margin: auto;\n}\n\n.error-message {\n  color: red;\n  margin-bottom: 20px;\n}\n\n.icon-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.icon-button svg {\n  font-size: 24px;\n  color: #007bff;\n}\n\n.icon-button svg:hover {\n  color: #0056b3;\n}\n\n.modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  max-width: 600px;\n  width: 100%;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n}\n\n.organization-form, .configuration-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.form-group label {\n  min-width: 200px;\n  text-align: right;\n  padding-right: 10px;\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n  min-width: 300px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: space-between;\n}\n\n.modal-actions button {\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.modal-actions button[type=\"submit\"] {\n  background-color: #4caf50;\n  color: #fff;\n}\n\n.modal-actions button[type=\"button\"] {\n  background-color: #ccc;\n}\n\n.modal-actions .delete-button {\n  background-color: #f44336;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
